import styled from 'styled-components';
import { H5 } from 'components/Typography';

import {
  mediaQueryTabletMin,
  mediaQueryMobileLargeMin,
  colorBlack900,
  fontFamilySecondary,
  fontFamilyPrimary,
  colorWhite2,
  mediaQueryDesktopMin,
} from 'styles';

import Select from 'components/commons/Select';
import { Wrapper as SectionWrapper } from 'components/CurrencyExchangeTable/styles';

export const AlertTitle = styled(H5)`
  margin-bottom: 4px;
`;

export const HeaderFilters = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
`;

export const Title = styled.h2`
  font-family: ${fontFamilySecondary};
  color: ${colorBlack900};
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
`;

export const ConverterWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: calc(100% - 64px);
  margin-bottom: 16px;

  @media all and ${mediaQueryMobileLargeMin} {
    flex-direction: row;
    align-items: center;
    width: 100%;
  }
`;

export const ConverterInputWrapper = styled.div`
  position: relative;
  flex: 1;

  &:first-of-type {
    margin-bottom: -1px;
  }

  @media all and ${mediaQueryTabletMin} {
    &:first-of-type {
      margin-right: 32px;
      margin-bottom: 0;
    }
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;

  & > div {
    margin-bottom: 0;
  }

  & button {
    padding: 0;
    height: 40px;
  }

  & button > div {
    right: unset;
    left: 0;
  }

  @media all and ${mediaQueryMobileLargeMin} {
    flex-direction: row;
    align-items: center;

    & button {
      height: 24px;
    }

    & button > div {
      right: 0;
      left: unset;
    }
  }
`;

export const ConverterInput = styled.input`
  height: 48px;
  font-size: 16px;
  line-height: 28px;
  color: ${colorBlack900};
  padding: 12px;
  border: none;
  width: 100%;

  @media all and ${mediaQueryDesktopMin} {
    font-size: 14px;
  }

  &:focus {
    outline: none;
  }
`;

export const InputWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #cacccb;
  border-radius: 2px;
  flex: 1;

  &:first-child {
    margin-bottom: 16px;
  }

  &:hover {
    border: 1px solid #87928c;
  }


  ${({ focus }) =>
    focus &&
    ` 
    box-shadow: 0px 0px 0px 2px #35A47C;

    &:hover {
      box-shadow: 0px 0px 0px 2px #35A47C;
    }
    `}

  @media all and ${mediaQueryMobileLargeMin} {
    &:first-child {
      margin-bottom: 0;
    }
  }
`;

export const ConverterLink = styled.a`
  display: inline-block;
  font-family: ${fontFamilyPrimary};
  font-size: 14px;
  line-height: 24px;
  font-weight: normal;
  color: ${colorWhite2};
`;

export const Wrapper = styled(SectionWrapper)`
  position: relative;
`;

export const ReverseButton = styled.button`
  color: rgba(0, 0, 0, 0.87);
  padding: 0;
  z-index: 4;
  font-size: 1rem;
  min-width: 0;
  box-sizing: border-box;
  min-height: 36px;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-weight: 500;
  line-height: 1.75;
  letter-spacing: 0.02857em;
  text-transform: uppercase;
  position: absolute;
  top: -8px;
  right: -63px;
  bottom: 0;
  margin: auto;
  border: none;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  background: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.16);

  & svg {
    transform: rotate(90deg);
  }

  @media all and ${mediaQueryMobileLargeMin} {
    display: block;
    position: static;
    margin: 0 16px;

    & svg {
      transform: rotate(0deg);
    }

    &:hover svg {
      transform: rotate(180deg);
    }
  }
`;

export const StyledSelect = styled(Select)`
  color: red;
`;
